import React from 'react';
import { AlertTriangle, Save, Trash2 } from 'lucide-react';

export interface OABExitConfirmModalProps {
  isOpen: boolean;
  itemsCount: number;
  onSaveDraftAndExit: () => void;
  onDiscardAndExit: () => void;
  onContinueEditing: () => void;
}

export const OABExitConfirmModal: React.FC<OABExitConfirmModalProps> = ({
  isOpen,
  itemsCount,
  onSaveDraftAndExit,
  onDiscardAndExit,
  onContinueEditing
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/85 backdrop-blur-md p-4 animate-fade-in no-print">
      <div className="bg-surface border border-borderSubtle rounded-2xl w-full max-w-md p-5 sm:p-6 shadow-2xl flex flex-col space-y-4">
        <div className="flex items-center gap-3 border-b border-borderSubtle pb-3">
          <div className="w-10 h-10 rounded-xl bg-amber-500/20 text-amber-300 border border-amber-500/40 flex items-center justify-center shrink-0">
            <AlertTriangle className="w-5 h-5" />
          </div>
          <div>
            <h3 className="text-sm font-bold text-slate-100">
              ¿Deseas salir de la solicitud?
            </h3>
            <p className="text-xs text-slate-400">
              Tienes <strong className="text-amber-300">{itemsCount} material(es)</strong> configurados en esta requisición.
            </p>
          </div>
        </div>

        <p className="text-xs text-slate-300 leading-relaxed">
          Puedes conservar tu borrador para continuar luego sin perder tus cambios, o descartarlo si ya no requieres emitir esta orden.
        </p>

        <div className="flex flex-col gap-2 pt-2">
          <button
            type="button"
            onClick={onSaveDraftAndExit}
            className="w-full flex items-center justify-center gap-2 py-2 px-4 bg-brand-500 hover:bg-brand-600 text-slate-950 font-bold rounded-xl text-xs transition shadow active:scale-95"
          >
            <Save className="w-4 h-4" />
            <span>Guardar borrador y salir</span>
          </button>

          <div className="grid grid-cols-2 gap-2">
            <button
              type="button"
              onClick={onDiscardAndExit}
              className="flex items-center justify-center gap-1.5 py-2 px-3 bg-rose-500/10 hover:bg-rose-500/20 text-rose-300 border border-rose-500/30 rounded-xl text-xs font-semibold transition active:scale-95"
            >
              <Trash2 className="w-3.5 h-3.5" />
              <span>Descartar borrador</span>
            </button>
            <button
              type="button"
              onClick={onContinueEditing}
              className="flex items-center justify-center py-2 px-3 bg-surfaceHigh hover:bg-surfaceHighest text-slate-200 border border-borderSubtle rounded-xl text-xs font-semibold transition active:scale-95"
            >
              <span>Seguir editando</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
